import { useSyncExternalStore } from 'use-sync-external-store/shim'
import { TelegramBanner } from '@/components/composed/TelegramSubscribeOverlayBanner/store/bannerStore'

export const useBannerStore = () => {
  const bannerStore = useSyncExternalStore(TelegramBanner.subscribe, TelegramBanner.getSnapshot)

  return { ...bannerStore, setBannerShown: TelegramBanner.setShown, setBannerClosed: TelegramBanner.setClosed }
}
